/**
 * Banchan365 — 장바구니 증정 규칙 엔진  (bc-cart-rules.js)  v1.2  2026-09-08
 *
 * 한 문장 요약
 *   "지금 장바구니에 있어야 할 증정품 목록"을 계산하고, 실제 장바구니와 다른 점만 고친다.
 *
 * 규칙 (여기 한 곳에서만 관리)
 *   1. 멤버십  : member-gift-eligible 태그 손님 + 실구매 상품 있음 → Secret Special Menu 1개
 *   2. 이벤트  : 세트 상품 메타필드 custom.event.gift_variant 가 있으면 → 세트 수량만큼 증정 (추석 굴비 등)
 *   → 다음 이벤트는 메타필드만 채우면 됨. 이 파일 수정 없음.
 *
 * 데이터 출처
 *   /cart.js 가 아니라 {root}?section_id=bc-cart-seed (snippets/bc-cart-seed.liquid).
 *   서버(Liquid)가 카트 + 메타필드 + 멤버십 여부를 한 번에 준다. 항상 새로 받는다 (캐시 없음).
 *
 * 언제 도는가 (테마가 원래 쏘는 신호 3개 + 외부 요청)
 *   ① 페이지 로드
 *   ② 장바구니 드로어 열림 (<details class="cart-drawer-container"> toggle) / 드로어 내용 첫 로드 (cartdrawer:opened)
 *   ③ 수량 변경·삭제 (테마 cart.js 가 쏘는 document 'cart:updated' + 수량 입력칸의 표준 change 이벤트)
 *   ④ window.bcCartRules.sync()  ← 체크아웃 직전 가드(main-cart-footer / event-system ensureGifts)가 호출
 *   window.fetch / XHR 가로채기, 폴링, DOM 감시 없음.
 *
 * 화면 갱신
 *   테마와 같은 방식(Section Rendering API)으로 드로어 / 카트 페이지를 다시 그림. 리로드 없음.
 *   증정 라인은 CSS 로 수량·삭제 버튼을 숨김 (손님이 못 건드림 → 항상 서버 상태 = 규칙 상태).
 *
 * 증정 라인 표식
 *   line item property  _bc_gift = "membership" | "event:<event id>"  (밑줄로 시작 → 화면엔 안 보임)
 *   예전 event-system 이 넣던 _free_gift 도 우리 것으로 인식해서 정리한다.
 */
(function () {
  'use strict';
  if (window.bcCartRules) return;

  /* ── 설정 ─────────────────────────────────────────────────────── */
  var MEMBERSHIP = {
    gift: 49057450426593,                                          /* Secret Special Menu $0 */
    topups: [49016615567585, 49016615600353, 49016615633121],      /* 멤버십 충전 상품 (실구매로 안 셈) */
    label: { 'Membership': "Tier 3 · this month's gift" }    /* 장바구니에 보이는 한 줄 */
  };
  var GIFT_PROP = '_bc_gift';
  var LEGACY_PROP = '_free_gift';
  var SEED_SECTION = 'bc-cart-seed';
  var DRAWER_SECTIONS = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];

  /* ── 내부 상태 ────────────────────────────────────────────────── */
  var onCartPage = document.body.classList.contains('template-cart');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var current = null;      /* 진행 중인 sync 의 Promise */
  var again = false;       /* 진행 중에 또 요청이 오면 끝나고 한 번 더 */
  var timer = null;
  var selfEvent = false;   /* 우리가 쏜 cart:updated 는 무시 */

  /* line item properties: /cart.js 는 객체, Liquid `| json` 은 [["키","값"], ...] 배열 → 둘 다 처리 */
  function hasProp(item, name) {
    var p = item.properties;
    if (!p) return false;
    if (Array.isArray(p)) {
      for (var i = 0; i < p.length; i++) if (p[i] && p[i][0] === name) return true;
      return false;
    }
    return p[name] != null;
  }
  /* 네트워크가 멈춰도 엔진이 영영 잠기지 않게 */
  function withTimeout(promise, ms) {
    return Promise.race([promise, new Promise(function (_, rej) { setTimeout(function () { rej(new Error('timeout')); }, ms); })]);
  }
  function isEn(seed) { return String(seed.locale || 'en').toLowerCase().indexOf('en') === 0; }

  /* ── 1) 스냅샷 받기 ───────────────────────────────────────────── */
  function fetchSeed() {
    return withTimeout(fetch(root + '?section_id=' + SEED_SECTION, { headers: { Accept: 'text/html' }, cache: 'no-store' }), 8000)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html').getElementById('bc-cart-seed');
        return el ? JSON.parse(el.textContent) : null;
      });
  }

  /* ── 2) 규칙 → 있어야 할 증정품 ──────────────────────────────── */
  function computeWant(seed) {
    var items = seed.items || [];
    var want = {};                 /* variantId(string) → { qty, props, event } */
    var eventGiftIds = {};
    items.forEach(function (it) { if (it.event && it.event.giftVariantId) eventGiftIds[String(it.event.giftVariantId)] = true; });

    function isGiftLine(it) {
      var vid = String(it.variant_id);
      return vid === String(MEMBERSHIP.gift) || !!eventGiftIds[vid] || hasProp(it, GIFT_PROP) || hasProp(it, LEGACY_PROP);
    }

    var real = 0;
    items.forEach(function (it) {
      if (!isGiftLine(it) && MEMBERSHIP.topups.indexOf(it.variant_id) === -1) real += it.quantity;
    });

    /* 규칙 1 — 멤버십 */
    if (seed.member_gift && real > 0) {
      var props = {}; for (var k in MEMBERSHIP.label) props[k] = MEMBERSHIP.label[k];
      props[GIFT_PROP] = 'membership';
      want[String(MEMBERSHIP.gift)] = { qty: 1, props: props, event: null };
    }

    /* 규칙 2 — 이벤트 세트 1개당 증정 1개 */
    items.forEach(function (it) {
      var ev = it.event;
      if (!ev || !ev.giftVariantId || isGiftLine(it)) return;
      var g = String(ev.giftVariantId);
      if (!want[g]) {
        var p = {}; p[GIFT_PROP] = 'event:' + ev.id;
        want[g] = { qty: 0, props: p, event: ev };
      }
      want[g].qty += it.quantity;
    });

    return { want: want, isGiftLine: isGiftLine };
  }

  /* ── 3) 실제 카트와 비교 → 고칠 것만 ─────────────────────────── */
  function plan(seed) {
    var c = computeWant(seed);
    var want = c.want;
    var updates = {};              /* line key → qty (0 = 삭제) */
    var adds = [];
    var seen = {};

    (seed.items || []).forEach(function (it) {
      if (!c.isGiftLine(it)) return;
      var vid = String(it.variant_id);
      var target = want[vid] ? want[vid].qty : 0;
      if (seen[vid]) { updates[it.key] = 0; return; }        /* 같은 증정이 두 줄이면 한 줄만 */
      seen[vid] = true;
      if (it.quantity !== target) updates[it.key] = target;
    });
    Object.keys(want).forEach(function (vid) {
      if (!seen[vid] && want[vid].qty > 0) {
        adds.push({ id: Number(vid), quantity: want[vid].qty, properties: want[vid].props });
      }
    });

    var lockIds = Object.keys(want).concat([String(MEMBERSHIP.gift)]);
    (seed.items || []).forEach(function (it) { if (c.isGiftLine(it)) lockIds.push(String(it.variant_id)); });

    return { updates: updates, adds: adds, want: want, lockIds: lockIds, seed: seed };
  }

  /* ── 4) 화면 갱신 (테마 cart.js / cart-drawer.js 와 같은 방식) ── */
  function sectionsToRender() {
    if (!onCartPage) {
      return DRAWER_SECTIONS.map(function (id) { return { id: id, section: id, selector: '.shopify-section' }; });
    }
    var list = [
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'mobile-cart-icon-bubble', section: 'mobile-cart-icon-bubble', selector: '.shopify-section' }
    ];
    var mi = document.getElementById('main-cart-items');
    var mf = document.getElementById('main-cart-footer');
    if (mi && mi.dataset.id) list.push({ id: 'main-cart-items', section: mi.dataset.id, selector: '.js-contents' });
    if (mf && mf.dataset.id) list.push({ id: 'main-cart-footer', section: mf.dataset.id, selector: '.js-contents' });
    return list;
  }

  function post(url, body) {
    body.sections = sectionsToRender().map(function (s) { return s.section; }).join(',');
    body.sections_url = window.location.pathname;
    return withTimeout(fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }), 10000).then(function (r) { return r.ok ? r.json() : null; });
  }

  function render(state) {
    if (!state || !state.sections) return;
    sectionsToRender().forEach(function (s) {
      var el = document.getElementById(s.id);
      var html = state.sections[s.section];
      if (!el || !html) return;
      var target = el.querySelector(s.selector) || el;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
      if (fresh) target.innerHTML = fresh.innerHTML;
    });
    if (window.bcDrawerShip) window.bcDrawerShip();            /* 드로어 무료배송 바 */
    selfEvent = true;                                          /* 다른 스크립트들(배너·추천·이벤트)에 알림 */
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'bc-cart-rules' } }));
    selfEvent = false;
  }

  /* 증정 라인의 수량 ± / 휴지통 숨김 (드로어 <li> + 카트 페이지 <tr>) */
  function lockUI(ids) {
    var css = '';
    ids.forEach(function (id) {
      css += 'body quantity-input.quantity:has(input[data-quantity-variant-id="' + id + '"]){display:none!important}';
      css += 'body :is(li,tr):has(input[data-quantity-variant-id="' + id + '"]) :is(cart-remove-button,.cart-item__remove){display:none!important}';
    });
    var el = document.getElementById('bc-cart-rules-lock');
    if (!el) { el = document.createElement('style'); el.id = 'bc-cart-rules-lock'; document.head.appendChild(el); }
    if (el.textContent !== css) el.textContent = css;
  }

  /* 이벤트 증정이 새로 담겼을 때만 작은 토스트 */
  function toast(p) {
    var en = isEn(p.seed);
    p.adds.forEach(function (a) {
      var w = p.want[String(a.id)];
      if (!w || !w.event) return;
      var ev = w.event, gt = ev.giftTitle ? String(ev.giftTitle).replace(/^🎁\s*/, '') : '';
      var msg = en
        ? '🎁 Your ' + (ev.nameEn || ev.name) + ' gift has been added!' + (gt ? ' (' + gt + ')' : '')
        : '🎁 ' + ev.name + ' 증정품이 함께 담겼어요!' + (gt ? ' (' + gt + ')' : '');
      var old = document.querySelector('.bc-rules-toast'); if (old) old.remove();
      var el = document.createElement('div');
      el.className = 'bc-rules-toast';
      el.textContent = msg;
      el.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(80px);' +
        'background:' + ((ev.color && /^#[0-9a-fA-F]{3,8}$/.test(ev.color)) ? ev.color : '#3D2C21') + ';color:#fff;' +
        'padding:14px 18px;border-radius:14px;font-size:13px;font-weight:500;z-index:10000;max-width:360px;' +
        'width:calc(100% - 32px);box-shadow:0 4px 20px rgba(0,0,0,.15);opacity:0;transition:all .4s cubic-bezier(.16,1,.3,1);';
      document.body.appendChild(el);
      setTimeout(function () { el.style.opacity = '1'; el.style.transform = 'translateX(-50%) translateY(0)'; }, 50);
      setTimeout(function () { el.style.opacity = '0'; setTimeout(function () { el.remove(); }, 400); }, 4000);
    });
  }

  /* ── 5) 한 사이클 ─────────────────────────────────────────────── */
  function sync() {
    if (current) { again = true; return current; }
    current = fetchSeed()
      .then(function (seed) {
        if (!seed) return false;
        var p = plan(seed);
        lockUI(p.lockIds);
        var hasUpd = Object.keys(p.updates).length > 0;
        var hasAdd = p.adds.length > 0;
        if (!hasUpd && !hasAdd) return false;

        var step = Promise.resolve(null);
        if (hasUpd) step = step.then(function () { return post(root + 'cart/update.js', { updates: p.updates }); });
        if (hasAdd) step = step.then(function (prev) {
          return post(root + 'cart/add.js', { items: p.adds }).then(function (s) { return s || prev; });
        });
        return step.then(function (state) {
          if (!state) return false;              /* 실패(품절 등)면 조용히 — 리로드 루프 만들지 않음 */
          render(state);
          toast(p);
          return true;
        });
      })
      .catch(function () { return false; })
      .then(function (changed) {
        current = null;
        if (again) { again = false; schedule(250); }
        return changed;
      });
    return current;
  }
  function schedule(ms) { clearTimeout(timer); timer = setTimeout(sync, ms); }

  /* ── 6) 신호 ──────────────────────────────────────────────────── */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sync(); });
  else sync();

  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('cart-drawer-container') && t.open) schedule(350);
  }, true);
  document.addEventListener('cartdrawer:opened', function () { schedule(150); });
  document.addEventListener('cart:updated', function () { if (!selfEvent) schedule(300); });
  /* ③' 수량 입력칸이 바뀔 때 (± 버튼도 결국 이 change 를 쏘다). 앱이 cart:updated 를 삼켜도 이건 들린다.
     테마 디바운스(300ms)+요청 뒤에 돌도록 1.5초 뒤 */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && (t.classList.contains('quantity__input') || t.name === 'updates[]')) schedule(1500);
  }, true);

  window.bcCartRules = { sync: sync, version: '1.2' };
})();
